import { useId } from '@radix-ui/react-id'
import Image from 'next/image'
import { ComponentProps } from 'react'
import { Stack } from '../Stack'
import {
  CheckboxContainer,
  CheckboxIcon,
  CheckboxInput,
  CheckboxLabelIcon,
  CheckboxRoot,
} from './Checkbox.styles'

type CheckboxOwnProps = ComponentProps<typeof CheckboxInput>

export type CheckboxProps = CheckboxOwnProps & {
  label: string
  hiddenLabel?: boolean
  name?: string
  variant?: 'primary' | 'secondary' | 'primaryRed'
  customCSS?: any
  labelIcon?: { src: string; height: number; width: number; iconCSS?: any }
  labelSize?: number
  checkboxSize?: 'small' | 'medium' | 'large'
}

export const Checkbox = ({
  id,
  label,
  hiddenLabel = false,
  disabled,
  name,
  checked,
  customCSS,
  labelIcon,
  checkboxSize,
  ...rest
}: CheckboxProps) => {
  const checkboxId = useId(id)

  return (
    <CheckboxRoot disabled={disabled} css={customCSS}>
      <CheckboxContainer size={checkboxSize}>
        <CheckboxInput
          type="checkbox"
          id={checkboxId}
          aria-label={hiddenLabel ? label : undefined}
          disabled={disabled}
          name={name}
          checked={checked}
          {...rest}
        />
        <CheckboxIcon name="check-fill" />
      </CheckboxContainer>
      {!hiddenLabel && (
        <label style={{ width: '100%' }} htmlFor={checkboxId}>
          <Stack direction="row" alignItems="center" css={customCSS}>
            {labelIcon && (
              <CheckboxLabelIcon size={labelIcon.iconCSS?.size}>
                <Image
                  src={labelIcon.src}
                  height={labelIcon.height}
                  width={labelIcon.width}
                  alt={label}
                  style={{ color: labelIcon.iconCSS?.color }}
                />
              </CheckboxLabelIcon>
            )}
            {label}
          </Stack>
        </label>
      )}
    </CheckboxRoot>
  )
}

Checkbox.displayName = 'Checkbox'
